<template>
	<Dropdown
		:label="label || $t('organization.company-size')"
		:name="name"
		:value="value"
		:options="companySizeOptions"
		:placeholder="$t('form.company-size.placeholder')"
		:error="error"
		:required="required"
		:disabled="disabled"
		@input="$emit('input', $event)"
		@focus="$emit('focus', $event)"
		@blur="$emit('blur', $event)"
	/>
</template>

<script>
import Dropdown from './Dropdown.vue'

export default {
	name: 'CompanySizeSelect',
	components: {
		Dropdown
	},
	props: {
		value: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: 'company_size'
		},
		label: {
			type: String,
			default: null
		},
		error: {
			type: String,
			default: null
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		companySizeOptions() {
			return [
				{
					label: this.$t('organization.company-size-options.1-20'),
					value: '1-20'
				},
				{
					label: this.$t('organization.company-size-options.21-50'),
					value: '21-50'
				},
				{
					label: this.$t('organization.company-size-options.51-100'),
					value: '51-100'
				},
				{
					label: this.$t('organization.company-size-options.101-250'),
					value: '101-250'
				},
				{
					label: this.$t('organization.company-size-options.251-500'),
					value: '251-500'
				},
				{
					label: this.$t('organization.company-size-options.501+'),
					value: '501+'
				}
			]
		}
	}
}
</script>
